export const knowledgeCategories = [
  {
    id: 'regulations',
    name: '法规政策',
    icon: 'ri-book-line',
    color: '#10B981',
    description: '财政、会计、财管、税务相关法规',
    subCategories: [
      { id: 'finance', name: '财政法规', count: 156 },
      { id: 'accounting', name: '会计准则', count: 203 },
      { id: 'management', name: '财务管理', count: 128 },
      { id: 'tax', name: '税务法规', count: 342 }
    ]
  },
  {
    id: 'interpretation',
    name: '政策解读',
    icon: 'ri-lightbulb-line',
    color: '#F59E0B',
    description: '专业解读最新财税政策',
    subCategories: [
      { id: 'tax-policy', name: '税收政策解读', count: 89 },
      { id: 'accounting-policy', name: '会计政策解读', count: 67 },
      { id: 'finance-policy', name: '财政政策解读', count: 54 }
    ]
  },
  {
    id: 'cases',
    name: '实务案例',
    icon: 'ri-file-list-3-line',
    color: '#8B5CF6',
    description: '真实案例分析与实践',
    subCategories: [
      { id: 'tax-planning', name: '税务筹划案例', count: 145 },
      { id: 'audit', name: '审计案例', count: 98 },
      { id: 'financial-analysis', name: '财务分析案例', count: 112 }
    ]
  },
  {
    id: 'industry',
    name: '行业动态',
    icon: 'ri-line-chart-line',
    color: '#EC4899',
    description: '行业最新发展趋势',
    subCategories: [
      { id: 'industry-news', name: '行业新闻', count: 234 },
      { id: 'market-analysis', name: '市场分析', count: 156 },
      { id: 'trend', name: '发展趋势', count: 89 }
    ]
  },
  {
    id: 'news',
    name: '最新资讯',
    icon: 'ri-newspaper-line',
    color: '#06B6D4',
    description: '财税领域最新动态',
    subCategories: [
      { id: 'daily-news', name: '每日资讯', count: 456 },
      { id: 'policy-update', name: '政策更新', count: 178 },
      { id: 'hot-topic', name: '热点话题', count: 234 }
    ]
  }
];

export const latestArticles = [
  {
    id: 1,
    title: '2024年增值税最新政策解读：小规模纳税人优惠政策延续',
    category: '政策解读',
    date: '2024-01-15',
    views: 2345,
    tags: ['增值税', '小规模纳税人', '税收优惠'],
    relatedCategories: ['regulations', 'interpretation']
  },
  {
    id: 2,
    title: '企业所得税汇算清缴实务操作指南及常见问题解答',
    category: '实务案例',
    date: '2024-01-14',
    views: 1876,
    tags: ['企业所得税', '汇算清缴', '实务操作'],
    relatedCategories: ['regulations', 'cases']
  },
  {
    id: 3,
    title: '新会计准则下收入确认的五步法模型详解',
    category: '法规政策',
    date: '2024-01-13',
    views: 3421,
    tags: ['会计准则', '收入确认', '准则解读'],
    relatedCategories: ['regulations', 'interpretation']
  },
  {
    id: 4,
    title: '数字经济时代下的税务合规管理新趋势',
    category: '行业动态',
    date: '2024-01-12',
    views: 1654,
    tags: ['数字经济', '税务合规', '行业趋势'],
    relatedCategories: ['industry', 'news']
  },
  {
    id: 5,
    title: '跨境电商企业税务筹划典型案例分析',
    category: '实务案例',
    date: '2024-01-11',
    views: 2987,
    tags: ['跨境电商', '税务筹划', '案例分析'],
    relatedCategories: ['cases', 'interpretation']
  },
  {
    id: 6,
    title: '财政部发布最新政府会计准则实施指南',
    category: '最新资讯',
    date: '2024-01-10',
    views: 1432,
    tags: ['政府会计', '准则指南', '政策发布'],
    relatedCategories: ['news', 'regulations']
  }
];

export const hotTopics = [
  { id: 1, title: '个人所得税专项附加扣除', heat: 9856 },
  { id: 2, title: '增值税留抵退税政策', heat: 8734 },
  { id: 3, title: '研发费用加计扣除', heat: 7621 },
  { id: 4, title: '小微企业税收优惠', heat: 6543 },
  { id: 5, title: '数字化转型税务处理', heat: 5432 }
];

export const knowledgeNetwork = [
  { from: 'regulations', to: 'interpretation', strength: 0.9 },
  { from: 'regulations', to: 'cases', strength: 0.8 },
  { from: 'interpretation', to: 'cases', strength: 0.85 },
  { from: 'cases', to: 'industry', strength: 0.7 },
  { from: 'industry', to: 'news', strength: 0.95 },
  { from: 'news', to: 'regulations', strength: 0.75 },
  { from: 'interpretation', to: 'industry', strength: 0.65 }
];